export default "__VITE_ASSET__042ac619__"